<script lang="ts">
  // Small product-wide "BETA" marker shown beside the empowered wordmark everywhere the
  // brand appears (header, footer, sign-in, landing). One source of truth so the
  // label reads identically across the app.
</script>

<span class="beta" aria-label="Beta">Beta</span>

<style>
  .beta {
    display: inline-flex;
    align-items: center;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    line-height: 1;
    padding: 2px 6px;
    border-radius: var(--radius-pill);
    color: var(--accent);
    background: var(--accent-soft);
    border: 1px solid color-mix(in srgb, var(--accent) 40%, transparent);
    white-space: nowrap;
    vertical-align: middle;
    /* Never inherit a gradient text-fill from a wordmark it sits next to. */
    -webkit-text-fill-color: currentColor;
  }
</style>
